import { SearchOutlined } from "@ant-design/icons";
import { useLazyQuery } from "@apollo/client";
import { Input, Select, Tag } from "antd";
import React, { useContext, useState, useEffect } from "react";
import { QueryContext } from "../context/queryContext";
import AUTOCOMPLETE_ORDERS from "../queries/autocompleteOrders";
import SEARCH_ORDERS from "../queries/searchOrders";
import GET_ORDERS from "../queries/getOrders";

const { Option } = Select;

function SearchField() {
  const [results, setResults] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [executeQuery] = useLazyQuery(GET_ORDERS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      try {
        if (data.getOrders) {
          setOrders(data.getOrders);
        }
      } catch (error) {}

      setIsSearched(false);
    },
    nextFetchPolicy: "no-cache",
    fetchPolicy: "no-cache",
  });
  const { setOrders, states, dateRange, setShouldLoadMore } =
    useContext(QueryContext);
  const [getResults, { loading: loadingResults }] = useLazyQuery(
    AUTOCOMPLETE_ORDERS,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        if (!loadingResults && data) {
          if (data.autocompleteOrder != null) {
            const options = [];
            data.autocompleteOrder.map((order) => {
              options.push({ value: order });
            });
            setResults(options);
          } else {
            setResults([]);
          }
        }
      },
    }
  );
  const [getSearch, { loading: loadingSearch, data: dataSearch }] =
    useLazyQuery(SEARCH_ORDERS, {
      onCompleted: () => {
        if (dataSearch.searchOrders.length > 0) {
          setOrders(dataSearch.searchOrders);
        } else {
          setOrders([]);
        }
      },
    });

  useEffect(() => {
    setShouldLoadMore(!isSearched);
  }, [isSearched]);

  async function handleSearch(term) {
    if (term.length >= 3) {
      await getResults({ variables: { searchTerm: term } });
    } else {
      setResults([]);
    }
  }

  async function search(term) {
    await getSearch({ variables: { searchTerm: term } });
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Select
        notFoundContent={null}
        filterOption={false}
        size="large"
        placeholder={
          <React.Fragment>
            <SearchOutlined />
            {" Vyhledejte.."}
          </React.Fragment>
        }
        id={"select"}
        prefix={<SearchOutlined />}
        defaultOpen={false}
        allowClear={true}
        showArrow={false}
        onBlur={() => {
          setResults([]);
        }}
        defaultActiveFirstOption={false}
        loading={loadingResults}
        options={results}
        showSearch
        style={{ width: "80%" }}
        onSearch={(term) => {
          handleSearch(term);
        }}
        onSelect={async (value) => {
          setIsSearched(true);
          await search(value);
        }}
        onInputKeyDown={async (e) => {
          if (e.key == "Enter") {
            setIsSearched(true);
            await search(e.currentTarget.value);
          }
        }}
      ></Select>
      {isSearched ? (
        <a
          onClick={async () => {
            await executeQuery({
              variables: {
                order: -1,
                states: states,
                offset: 0,
                createdAfter: dateRange[0],
                createdBefore: dateRange[1],
              },
            });
          }}
        >
          Zrušit vyhledávání
        </a>
      ) : null}
    </div>
  );
}

export default SearchField;
